export const themeColor = "#6100d4";
export const darkThemeColor = "#f0f0f0";
export const hoverEffect = `rgba(0, 0, 0, 0.1) 0px 10px 20px 2px`;
export const cardShadow = `rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,
    rgba(0, 0, 0, 0.04) 0px 10px 10px -5px`;
